import { render } from "./ExtranetApiLog.vue?vue&type=template&id=6b8639b2&scoped=true"
import script from "./ExtranetApiLog.vue?vue&type=script&lang=js"
export * from "./ExtranetApiLog.vue?vue&type=script&lang=js"

import "./ExtranetApiLog.vue?vue&type=style&index=0&id=6b8639b2&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8639b2"]])

export default __exports__